// Vendor imports
const Immutable = require('immutable')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')
// Sibling imports
const LocationRecord = require('./records/location')

class RouterRecord extends Immutable.Record({
  action: String(),
  entry: String(),
  location: new LocationRecord(),
  title: String()
}) {
  setLocation(location) {
    return this.merge({
      location: new LocationRecord(location)
    })
  }
}

const reviver = keyedReviver(RouterRecord, {
  location: LocationRecord.reviver
})

module.exports = Object.assign(RouterRecord, {
  reviver
})
